/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Deck name (optional)" |
*
* @param {Deck_Upload_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_name_placeholder = /** @type {((inputs?: Deck_Upload_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Name_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du deck (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del deck (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do deck (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del deck (facoltativo)")
	return /** @type {LocalizedString} */ ("Deck name (optional)")
});